import type { ActivityAttachment, ActivityAttachmentKind } from "../types/reviewTypes";

const DOCUMENT_EXTENSIONS = new Set(["pdf", "doc", "docx", "txt", "rtf", "md"]);
const IMAGE_EXTENSIONS = new Set(["jpg", "jpeg", "png", "gif", "webp", "svg"]);
const VIDEO_EXTENSIONS = new Set(["mp4", "mov", "webm", "m4v"]);
const SPREADSHEET_EXTENSIONS = new Set(["csv", "xls", "xlsx", "ods"]);
const PRESENTATION_EXTENSIONS = new Set(["ppt", "pptx", "key"]);
const ARCHIVE_EXTENSIONS = new Set(["zip", "rar", "7z", "tar", "gz"]);

export function getFileExtension(fileName: string): string {
  const extension = fileName.trim().split(".").pop()?.toLowerCase();
  return extension && extension !== fileName.toLowerCase() ? extension : "";
}

export function getAttachmentKind(fileName: string, url?: string | null): ActivityAttachmentKind {
  if (url?.startsWith("http") && !getFileExtension(fileName)) {
    return "link";
  }

  const extension = getFileExtension(fileName);
  if (DOCUMENT_EXTENSIONS.has(extension)) return "document";
  if (IMAGE_EXTENSIONS.has(extension)) return "image";
  if (VIDEO_EXTENSIONS.has(extension)) return "video";
  if (SPREADSHEET_EXTENSIONS.has(extension)) return "spreadsheet";
  if (PRESENTATION_EXTENSIONS.has(extension)) return "presentation";
  if (ARCHIVE_EXTENSIONS.has(extension)) return "archive";
  return "file";
}

export function getAttachmentFileType(fileName: string): string {
  const extension = getFileExtension(fileName);
  return extension ? extension.toUpperCase() : "Link";
}

export function isAttachmentOpenAction(attachment: Pick<ActivityAttachment, "kind">): boolean {
  return attachment.kind === "link";
}

export function isAttachmentDownloadable(attachment: Pick<ActivityAttachment, "kind">): boolean {
  return !isAttachmentOpenAction(attachment);
}

export function createActivityAttachment({
  id,
  fileName,
  url,
}: {
  id: string;
  fileName: string;
  url?: string | null;
}): ActivityAttachment {
  return {
    id,
    fileName,
    fileType: getAttachmentFileType(fileName),
    kind: getAttachmentKind(fileName, url),
    url: url ?? undefined,
  };
}
